import styled from 'styled-components';
import { layout, media } from '@prisjakt/ui-base';
import {
  DEFAULT_STORE_LOGO_MAX_WIDTH,
  VARIANTS,
} from '@prisjakt/ui-store-logo';

export { VARIANTS };

export const StoreInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  width: 104px;
  padding: ${layout.measurements.spacing050};
  margin: 0;

  ${media.smallOnly`
    padding-left: 0;
  `}

  /* Small mobile resolutions, e.g. Galaxy Fold */
  @media screen and (max-width: 280px) {
    width: calc(
      ${DEFAULT_STORE_LOGO_MAX_WIDTH}px + ${layout.measurements.spacing050}
    );
  }
`;

export const StoreInfoTitle = styled.span`
  /* Visually hidden since this text is primarily for Google */
  position: absolute;
  left: -10000px;
  top: auto;
  width: 1px;
  height: 1px;
  overflow: hidden;
`;
